"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.seoMarkForSeoOrder = exports.seoOrderOverdueTime = void 0;
var seoLocationWatcher_1 = require("./seoLocationWatcher");
var seoMarkForSeoOrderMark_1 = require("./seoMarkForSeoOrderMark");
// 有来自seo页面的标识时，存储到本地标记，用于订单带入来自seo，做订单来源统计
exports.seoOrderOverdueTime = 1000 * 60 * 60 * 24;
function seoMarkForSeoOrder() {
    var isFromSeo = window.location.search.indexOf(seoLocationWatcher_1.isFromSeoStr) !== -1;
    var now = new Date().getTime();
    var overdue = now + exports.seoOrderOverdueTime;
    if (isFromSeo) {
        window.localStorage.setItem(seoMarkForSeoOrderMark_1.seoMarkForSeoOrderKey, JSON.stringify({ overdue: overdue }));
    }
}
exports.seoMarkForSeoOrder = seoMarkForSeoOrder;
